module.exports = __webpack_public_path__ + "img/LKTin_Gray_1280x1010.bea4865e.jpg";